import React from 'react'
import { Link } from "react-router-dom";

export default function HaldiHead({headdata}) {
  return (
    <>
    <section className="haldipage-head">
        <div className="container">
            <div className="row justify-content-center">

                <div className="col-lg-10 col-md-10">
                    <span>{headdata.title}</span>
                    <h1>{headdata.heading}</h1>
                    <p className="wow animate__animated animate__fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">{headdata.description}</p>
                    <Link to={headdata.link} className="default-btn red-default">learn more</Link>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
